import { useFeatureValue } from '@growthbook/growthbook-react';
import { useEffect, useState } from 'react';
import FullScreenNotification from 'src/features/inAppNotifications/presentation/components/FullScreenNotification';
import { InAppNotificationProps } from 'src/features/inAppNotifications/presentation/components/InAppNotification/InAppNotification.types';
import ModalNotification from 'src/features/inAppNotifications/presentation/components/ModalNotification';
import useTrackInAppNotificationEvents from 'src/features/inAppNotifications/presentation/hooks/useTrackInAppNotificationEvents';
import { InAppNotificationType } from 'src/types/common';
import { FEATURE_FLAGS } from 'src/utils/growthBook/growthBook.constants';

const InAppNotification: React.FC<InAppNotificationProps> = ({
  notification,
  onClose: handleClose,
  ...props
}) => {
  const { trackNotificationClick, trackNotificationView } =
    useTrackInAppNotificationEvents();
  const [lastTrackedNotification, setLastTrackedNotification] = useState<
    number | null
  >(null);

  const notificationTimeoutSeconds = useFeatureValue(
    FEATURE_FLAGS.IN_APP_NOTIFICATIONS_DURATION,
    3
  );

  useEffect(() => {
    if (notification) {
      const timeoutId = setTimeout(() => {
        handleClose('timeout');
      }, notificationTimeoutSeconds * 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [notification, notificationTimeoutSeconds, handleClose]);

  useEffect(() => {
    if (!!notification && notification.pk !== lastTrackedNotification) {
      setLastTrackedNotification(notification.pk);
      trackNotificationView(notification);
    }
  }, [notification, lastTrackedNotification, trackNotificationView]);

  if (!notification) return null;

  const handleContentClick = () => {
    trackNotificationClick(notification);
    handleClose('content_click');
  };

  if (notification.type === InAppNotificationType.FullScreen)
    return (
      <FullScreenNotification
        notification={notification}
        onClose={handleClose}
        onContentClick={handleContentClick}
        {...props}
      />
    );

  if (notification.type === InAppNotificationType.Modal)
    return (
      <ModalNotification
        notification={notification}
        onClose={handleClose}
        onContentClick={handleContentClick}
        {...props}
      />
    );

  return null;
};

export default InAppNotification;
